import { useEffect, useState } from 'react'

export const useYupPhone = () => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false)

  useEffect(() => {
    const loadYupPhone = async () => {
      await import('yup-phone-lite')
      setIsLoaded(true)
    }

    loadYupPhone()
  }, [])

  return isLoaded
}
